module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.11-241.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.11.md
// module id = 685
// module chunks = 284